import './person.less';
import * as _ from 'lodash';
import { PersonHasLoanedEquipment } from '../server/ApiWarnings';

angular.module("tromanWeb").controller('PersonController', ['stateService', 'dialogService', 'tromanServer', 'personArchive', 'isTroman', 'systemInfo', 'personState', function (stateService, dialogService, tromanServer, personArchive, isTroman, systemInfo, personState) {

    this.parties = personState.parties;
    this.divisions = personState.divisions;
    this.person = personState.person;
    this.enableArchive = !!(this.person.Id && this.person.Active);
    this.isPolitikerEnabled = systemInfo.IsPolitikerEnabled;

    this.canArchive = function () {
        if (!this.enableArchive) return false;
        if (personState.form != null) {
            if (personState.form.$dirty)
                return false;
        }

        return true;
    };

    this.canActivate = function () {
        if (this.enableArchive) return false;
        if (personState.form != null) {
            if (personState.form.$dirty)
                return false;
        }

        return true;
    };

    this.archive = function archive() {
        if (!this.canArchive()) return;

        personArchive.archiveSingle(this.person).then(opt => {
            tromanServer.Persons.archive(this.person, opt.clearContact, opt.unpublish, opt.politikerExpireDate, opt.deleteFiles)
                .then(warnings => {
                    if (_.has(warnings, PersonHasLoanedEquipment)) {
                        return dialogService.warning(['Personen har arkiverats.', { text: 'Personen har fortfarande utlånad utrustning.', iserror: true }]);
                    }
                })
                .then(() => { stateService.forceReload(); })
                .catch(dialogService.error);
        });
    };

    this.activate = function activate() {
        if (!this.canActivate()) return;

        dialogService.confirm(["Aktivera " + this.person.name + ".", "Är du säker?"]).then(() => {
            tromanServer.Persons.activate(this.person.Id)
                .then(() => { stateService.forceReload(); })
                .catch(dialogService.error);
        });
    };

    this.hardRemove = function hardRemove() {
        if (this.person == null || this.person.Id == null) return;

        const confirmText = ['Radera ' + this.person.name + ' permanent.', 'Detta kan inte ångras', 'Är du säker?'];

        if (isTroman) {
            dialogService.confirm(confirmText).then(() => {
                tromanServer.Persons.hardRemove(this.person.Id)
                    .then(() => { stateService.forceGo('persons'); })
                    .catch(dialogService.error);
            });
        } else {
            let remove = (purge) => {
                if (purge) {
                    return tromanServer.Persons.purge(this.person.Id);
                } else {
                    return tromanServer.Persons.hardRemove(this.person.Id);
                }
            };
    
            let msg = {
                message: confirmText,
                options: {
                    text: 'Radera personen totalt (inklusive t.ex. uppdrag och arvoden med mera).',
                    value: false
                }
            };
    
            dialogService.confirmAdvanced(msg).then(purgePerson => {
                remove(purgePerson.value)
                    .then(() => { stateService.forceGo('persons'); })
                    .catch(dialogService.error);
            });
        }
    };

    this.createReport = function createReport() {
        var list = [this.person];
        dialogService.createReport({ persons: list });
    };
}]);
